<template>
  <div class="field">
    <label :class="this.$parent.isFieldRequired(this.keyData) ? 'req': ''" class="required">{{ label }}</label>
    <input @focus="isFocused=true" @blur="(e) => {isFocused=false; updateServerValue(e)}" :disabled="isDataUpdating" :value="currentDataFormated" @change="updateServerValue" type="date">
  </div>
</template>

<script>
import 'moment-timezone';
import moment from "moment";

export default {
  name: "DataInput.vue",
  props: [
    'currentData',
    'keyData',
    'label',
    'topLevel',
    'isDataUpdating'
  ],
  data() {
    return {
      isFocused: false
    }
  },
  methods: {
    updateServerValue(e) {
      if (!this.isFocused) {
        if (this.topLevel === undefined) {
          this.$parent.project[this.keyData] = e.target.value;
        }
        else {
          this.$parent.project[this.topLevel][this.keyData] = e.target.value;
        }
        this.$parent.saveData();
      }
    }
  },
  computed: {
    currentDataFormated() {
      return moment(this.currentData).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>

</style>